import { colors } from "../../styles/theme";
import type { GesamtstatusDomain } from "../../types";

/**
 * Farbcodierung für den Gesamtstatus-Badge: "Neu" grau, abgeschlossen ("In Betrieb") grün, alle
 * übrigen Zwischenstände blau. Ob abgeschlossen, sagt der Server (`gesamtstatus_abgeschlossen`).
 */
export function getGesamtstatusColor(
  gesamtstatusDomain: GesamtstatusDomain,
  abgeschlossen: boolean,
): {
  background: string;
  main: string;
} {
  if (gesamtstatusDomain === "neu") {
    return colors.domainProgress.notStarted;
  }
  return abgeschlossen
    ? colors.domainProgress.completed
    : colors.domainProgress.inProgress;
}

/** Erste Option einer Domäne ist per Konvention immer "nicht gestartet" (kein echter Status). */
export function isPlaceholderStatus(value: string, options: string[]): boolean {
  return options.length > 0 && value === options[0];
}

/**
 * Farbe für ein Domänen-Status-Dropdown (Fläche, Planungsrecht, Genehmigung, Ausschreibung,
 * Finanzierung, Bau): einheitlich nach Fortschrittsstufe - "nicht gestartet" grau, der
 * Zwischenstatus blau, die letzte Stufe (abgeschlossen) grün. Alle Domänen haben genau 3
 * Stufen, daher reicht die Position in der Optionsliste.
 */
export function getDomainStatusColor(
  domain: GesamtstatusDomain,
  value: string,
  options: string[],
): string {
  if (isPlaceholderStatus(value, options)) {
    return colors.domainProgress.notStarted.background;
  }
  const isComplete =
    options.length > 0 && value === options[options.length - 1];
  return isComplete
    ? colors.domainProgress.completed.background
    : colors.domainProgress.inProgress.background;
}

/**
 * Icon-Typ für das Domänen-Label: 'check' sobald die letzte (abgeschlossene) Stufe erreicht
 * ist, sonst kein Icon.
 */
export function getDomainStatusIcon(
  domain: GesamtstatusDomain,
  value: string,
  options: string[],
): "check" | null {
  const isComplete =
    options.length > 0 && value === options[options.length - 1];
  return isComplete ? "check" : null;
}
